/* Property search filters: reads status, type, area, price and sort criteria from the URL query. */
import { app, Component } from 'apprun';
import { __ } from './Txlat';

declare const jQuery;

const search = () => {
  const url = new URL(window.location.href);
  const keyword = (document.querySelector('input[name="keyword"]') as HTMLInputElement).value;

  // Remove everything after properties-by-location for location-based URLs
  if (url.pathname.includes('properties-by-location/')) {
    const baseUrl = new URL(window.location.origin);
    baseUrl.pathname = '/properties-by-location';
    url.pathname = baseUrl.pathname;
  }

  url.searchParams.set('keyword', keyword);
  window.history.pushState({}, '', url.href);
  app.run('#');

  return false;
};

export class SearchFilter extends Component {

  view = (state) => {
    if (!state) {
      return;
    }

    // Determine the price label based on the selected status
    const priceLabel = [
      state.forSale || !state.forLease ? __('Sale Price') : null,
      state.forSale && state.forLease || !state.forSale && !state.forLease ? ' | ' : null,
      state.forLease || !state.forSale ? __('Lease Rate ($/SF/Mo/YR)') : null
    ].filter(Boolean).join('');

    return (
      <div class="container">
        <form autocomplete="off" onsubmit={search}>
          <div class="d-flex">
            <div class="flex-search full-width ">
              <div class="form-group">
                <div class="search-icon d-flex flex-nowrap">
                  <input name="keyword" type="text" class="form-control mx-1" value={state.keyword}
                    placeholder={__('"City", "Postal Code", "Neighbourhood", "MLS#"')} />
                  <button type="submit" class="btn btn-search btn-secondary">{__('Search')}</button>
                </div>
              </div>
            </div>
          </div>
          <a href="#filter" data-toggle="collapse"><b>{__('Advanced Search ...')}</b></a>

          <div id="filter" class="collapse">
            <div class="d-flex flex-lg-row flex-column">

              <div class="m-1" style="flex:1">
                <div class="form-group">
                  <select id="select_status" name="status[]" data-size="5" class="selectpicker form-control bs-select-hidden"
                    title={__('Status')}
                    data-live-search="false"
                    data-selected-text-format="count > 1"
                    data-actions-box="true" multiple data-select-all-text={__('Select All')}
                    data-deselect-all-text={__('Deselect All')} data-none-results-text={`${__('No results matched')} {0}`}
                    data-count-selected-text={'{0} ' + __('Statuses')} data-container="body"
                    onchange="app.run('/updatePriceLabel'); app.run('/filter-list');">

                    <option data-ref="for-lease" value="for-lease" selected={state.forLease ? 'selected' : ''}>{__('For Lease')}</option>
                    <option data-ref="for-sale" value="for-sale" selected={state.forSale ? 'selected' : ''} >{__('For Sale')}</option>
                  </select>
                </div>
              </div>
              <div class="m-1" style="flex:1">
                <div class="form-group">
                  <select name="type[]" data-size="5" class="selectpicker form-control bs-select-hidden"
                    title={__('Type')} data-live-search="true" data-selected-text-format="count > 1"
                    data-actions-box="true" multiple data-select-all-text={__('Select All')}
                    data-deselect-all-text={__('Deselect All')} data-count-selected-text={'{0} ' + __('Types')}
                    data-none-results-text={`${__('No results matched')} {0}`} data-container="body"
                    onchange="app.run('/filter-list')">
                    <option data-ref="agricultural" value="agricultural" selected={state.allTypes?.indexOf('agricultural') >= 0 ? 'selected' : ''}>{__('Agricultural')}</option>
                    <option data-ref="business" value="business" selected={state.allTypes?.indexOf('business') >= 0 ? 'selected' : ''}>{__('Business')}</option>
                    <option data-ref="hotels/motels" value="hotels/motels" selected={state.allTypes?.indexOf('hotels/motels') >= 0 ? 'selected' : ''}>{__('Hotels/Motels')}</option>
                    <option data-ref="industrial" value="industrial" selected={state.allTypes?.indexOf('industrial') >= 0 ? 'selected' : ''}>{__('Industrial')}</option>
                    <option data-ref="investment" value="investment" selected={state.allTypes?.indexOf('investment') >= 0 ? 'selected' : ''}>{__('Investment')}</option>
                    <option data-ref="land" value="land" selected={state.allTypes?.indexOf('land') >= 0 ? 'selected' : ''}>{__('Land')}</option>
                    <option data-ref="multi-family" value="multi-family" selected={state.allTypes?.indexOf('multi-family') >= 0 ? 'selected' : ''}>{__('Multi Family')}</option>
                    <option data-ref="retail" value="retail" selected={state.allTypes?.indexOf('retail') >= 0 ? 'selected' : ''}>{__('Retail')}</option>
                    <option data-ref="office" value="office" selected={state.allTypes?.indexOf('office') >= 0 ? 'selected' : ''}>{__('Office')}</option>
                    <option data-ref="other" value="other" selected={state.allTypes?.indexOf('other') >= 0 ? 'selected' : ''}>{__('Other')}</option>
                  </select>
                </div>
              </div>
              <div class="m-1" style="flex:1">
                <div class="form-group">
                  <input name="min-area" type="text" class="form-control" value={state.minArea} placeholder={__('Min. Sq ft')}
                    onblur="app.run('/filter-list')" />
                </div>
              </div>
              <div class="m-1" style="flex:1">
                <div class="form-group">
                  <input name="max-area" type="text" class="form-control" value={state.maxArea} placeholder={__('Max. Sq ft')}
                    onblur="app.run('/filter-list')" />
                </div>
              </div>
            </div>

            <b id="price-label"  name="price-label">{priceLabel}</b>

            <div class="d-flex flex-lg-row flex-column">

              <div class="m-1" style="flex:1">
                <div class="form-group">
                  <input name="min-price" type="text" class="form-control" value={state.minPrice} placeholder={__('Min')}
                    onblur="app.run('/filter-list');" />
                </div>
              </div>
              <div class="m-1" style="flex:1">
                <div class="form-group">
                  <input name="max-price" type="text" class="form-control" value={state.maxPrice} placeholder={__('Max')}
                    onblur="app.run('/filter-list')" />
                </div>
              </div>

              <div class="m-1" style="flex:1">&nbsp;</div>
              <div class="m-1" style="flex:1">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="exclusiveListing" name="exclusiveListing" onchange="app.run('/filter-list')" checked={state.exclusiveListing} />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<label class="form-check-label" for="exclusiveListing">{__('Exclusive Listings')}</label>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>

    );
  };
  update = {
    '#': () => {
      // URLSearchParams decodes each value and tolerates malformed escapes such as a bare '%'.
      const params = new URLSearchParams(location.search);
      const statuses = params.getAll('status[]');
      // Prefix match keeps the French values (for-lease_fr, for-sale_fr) selecting the same status.
      const forLease = statuses.some(status => status.startsWith('for-lease'));
      const forSale = statuses.some(status => status.startsWith('for-sale'));
      const allTypes = params.getAll('type[]');
      const keyword = params.get('keyword') ? params.get('keyword').trim() : '';

      const exclusiveListing = params.get('exclusive-listing') ? params.get('exclusive-listing') : '';

      let allStatusStr = '';
      for (const status of params.getAll('status[]')) {
        if (status.length) {
          if (allStatusStr === '') {
            allStatusStr = `'${status.replace('for-', '')}'`;
          } else {
            allStatusStr += `,'${status.replace('for-', '')}'`;
          }
        }
      }

      let allTypeStr = '';
      for (const type of allTypes) {
        if (allTypeStr === '') {
          allTypeStr = `'${type}'`;
        } else {
          allTypeStr += `,'${type}'`;
        }
      }

      const minPrice = params.get('min-price') ? params.get('min-price') : '';
      const maxPrice = params.get('max-price') ? params.get('max-price') : '';

      const minArea = params.get('min-area') ? params.get('min-area') : '';
      const maxArea = params.get('max-area') ? params.get('max-area') : '';

      const sortBy = params.get('sortby') ? params.get('sortby') : '';

      const page = params.get('page') ? params.get('page') : '1';

      return { forLease, forSale, allTypes, keyword, minArea, maxArea, sortBy, page, minPrice, maxPrice, exclusiveListing };
    },

    '/updatePriceLabel': () => {

      const statusSelect = document.getElementById('select_status') as HTMLSelectElement;
      const selectedStatuses = Array.from(statusSelect.selectedOptions).map(option => option.value);
      const priceLabelElement = document.getElementById('price-label') as HTMLSelectElement;

      let label = '';

      if (selectedStatuses.length === 0) {
        label = `${__('Sale Price')} | ${__('Lease Rate ($/SF/Mo/YR)')}`;
      } else {
        if (selectedStatuses.includes('for-sale')) {
          label += __('Sale Price');
        }
        if (selectedStatuses.includes('for-lease')) {
          if (label) { label += ' | '; }
          label += __('Lease Rate ($/SF/Mo/YR)');
        }
      }

      if (priceLabelElement) {
        priceLabelElement.textContent = label;
      }

    }
  };

  rendered = () => {
    jQuery('.selectpicker').selectpicker('refresh');
  };

}
